module.exports = __webpack_public_path__ + "static/media/convo_lock.9fd9731f.svg";